import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyNo = () => {
    return <PrivacyPolicy languageCode="no" />
}

export default PrivacyPolicyNo
